import Api from "~/utils/Api"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

export interface HeatmapHour {
  hour: number
  work: number
  back_to_back: number
  break: number
}

export interface HeatmapDay {
  date: string
  hours: HeatmapHour[]
}

export const useHeatmap = (userId: string, weekOffset = 0) =>
  useQuery({
    placeholderData: keepPreviousData,
    queryKey: ["heatmap", userId, weekOffset],
    queryFn: () =>
      Api.get(`users/${userId}/heatmap`, {
        params: { week_offset: weekOffset },
      }).then((response) => response.data as HeatmapDay[]),
  })
